      <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">X</span>
        </button>
        <storever-header-modal [title]="'GENERIC_REMOVE_PLAYER'" [icon]="'fal fa-trash-alt'"></storever-header-modal>
      </div>
      <storever-header-subtitle  [datas]="[{icon: 'fal fa-hdd', title: 'GENERIC_PLAYER_INFO', name: selectedPlayer?.deviceID}]
      "></storever-header-subtitle>
      <div class="modal-body">
        <div class="portlet-body">
          <div *ngIf="displayPlayerList() ; else remove">
            <div>{{'REMOVE_PLAYER_LIST_UPDATE_NEW_ONE_DEFAULT' | translate:locale.language}} </div><br>
            <form [formGroup]="form">
              <storever-element-group
                #elementGroup
                [icon]="'fal fa-hdd'"
                [title]="'none'"
                [config]="formConfig.config"
                [form]="form">
              </storever-element-group>
            </form>
          </div>
          <ng-template #remove> {{'REMOVE_PLAYER_MESSAGE' | translate:locale.language}} </ng-template>
          <br>
          <br>
          <label class="row col-sm-3 control-label" style="white-space: nowrap;margin-right: 8px;">
            {{"REMOVE_PLAYER_IS_LOST_OR_SOLD" | translate:locale.language}}
          </label>
          <div class="col-sm-9">
            <label class="control-label container pull" >
              <input type="checkbox" class="form-check-input" [(ngModel)]="showhideReason"/>
              <span class="checkmark"></span>
            </label>
          </div>
          <br>
          <br>
          <div class="prolongationTextArea" *ngIf="showhideReason">
            <label>{{'REASON_REMOVE'| translate:locale.language}}</label>
            <storever-dynamic-form [config]="formConfigSoldOrLost.config" [form]="formSoldOrLost" [stylingClass]="'dynamic-form-list'"></storever-dynamic-form>
          </div>

        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger"
                *ngIf="displayPlayerList(); else removeBTN"
                [disabled]="showhideReason ? !formSoldOrLost.get('reason').value : false "
                (click)="sendWithForm()">
           <i class="fal fa-trash-alt"></i>
           {{'GENERIC_REMOVE' | translate:locale.language}}
        </button>
        <ng-template #removeBTN>
          <button  type="button" class="btn btn-danger"
                   [disabled]="showhideReason ? !formSoldOrLost.get('reason').value : false "
                  (click)="send()">
            <i class="fal fa-trash-alt"></i>
            {{'GENERIC_REMOVE' | translate:locale.language}}
          </button>
        </ng-template>
        <button type="button" class="btn btn-default" (click)="close()">{{'CANCEL' | translate:locale.language}}</button>
      </div>
